export enum ROUTES {
    home = "/",
    login = "/login",
    signIn = "/signin",
    hub = "/hub",
    mediaLists = "/media-lists",
    physicalMovieCollection = "/physical-movie-collection",
    physicalGameCollection = "/physical-game-collection",
    productivity = "/productivity",
    watchlist = "/watchlist",
    gameList = "/gamelist",
    tvShows = "/tvshows",
    comicShelf = "/comic-shelf"
  }
  
  export const WEEKDAYS = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];